import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export const BILLING_LOCKED_MESSAGE = 'Contact customer support to change your plan.'

/**
 * Shared tooltip for billing controls locked during the payments-provider migration.
 * Pass `className="w-full"` when wrapping a full-width CTA in a centered or
 * shrink-to-fit parent, otherwise the span collapses the child to text width.
 */
export function BillingLockedTooltip(props: {
  children: React.ReactNode
  message?: string
  className?: string
}): JSX.Element {
  const { children, message, className } = props

  return (
    // Owns its provider so it works on surfaces that don't already have one;
    // nesting a provider inside an existing one is safe with Radix.
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* Wrapper span keeps the tooltip working while the child is
              disabled (disabled elements don't emit pointer events). */}
          {/* tabIndex puts the wrapper in the tab order: the child is disabled
              (unfocusable), and keyboard users still deserve the explanation. */}
          <span tabIndex={0} className={cn('inline-flex', className)}>{children}</span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[220px] text-xs">
          {message ?? BILLING_LOCKED_MESSAGE}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
